import { Input } from '@angular/core';
import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { finalize } from 'rxjs/operators';
import { AppService } from '../../services/app.service';
import { EmployeeCardService } from '../../services/employee-card.service';
import { IEmployeeCard } from '../../models/EmployeeCard';
import { ClassifierService } from '../../services/classifier.service';
import { IClassifier } from '../../models/Classifier';

@Component({
    selector: 'app-employee-card-revoke',
    templateUrl: './revoke.component.html'
})
export class EmployeeCardRevokeComponent {
    constructor(
        private app: AppService,
        private service: EmployeeCardService,
        private classifierService: ClassifierService,
        private activeModal: NgbActiveModal
    ) { }

    @Input() card: IEmployeeCard;

    reasons: IClassifier[] = [];
    reasonId: string;

    isSaving: boolean;

    ngOnInit() {
        this.classifierService.get('EmployeeCardRevocationReason').subscribe(data => {
            this.reasons = data;
        });
    }

    submit() {
        const success = () => {
            this.app.notify(this.app.translate('employeeCard_revoked'));
            this.activeModal.close();
        };

        this.isSaving = true;

        this.app.addLoading(this.service.revoke(this.card.Id, this.reasonId), 500)
            .pipe(finalize(() => this.isSaving = false)).subscribe(success);
    }

    cancel() {
        this.activeModal.dismiss();
    }
}
